[
  {
    "priority_order": 1,
    "node_id": "N01",
    "category_name": "Pure Clinical Neuroscience",
    "lead_mentor": "Kian (McMaster Neuroscience Scholar)",
    "co_mentor": "Health Sci Specialist",
    "threshold_struct": {
      "primary_domain": "STEM",
      "conditions": [
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.4
        },
        {
          "domain": "AI",
          "op": "<",
          "value": 0.25
        },
        {
          "domain": "ENG",
          "op": "<",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 2,
    "node_id": "N02",
    "category_name": "Computational Neuroscience",
    "lead_mentor": "Kian (McMaster Neuroscience Scholar)",
    "co_mentor": "Sadeghi (AI Lead)",
    "threshold_struct": {
      "primary_domain": "STEM",
      "conditions": [
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 3,
    "node_id": "N03",
    "category_name": "Neuro-Tech & Bio-Hardware",
    "lead_mentor": "Kian (McMaster Neuroscience Scholar)",
    "co_mentor": "Math/Physics Specialist",
    "threshold_struct": {
      "primary_domain": "STEM",
      "conditions": [
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "ENG",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 4,
    "node_id": "N04",
    "category_name": "Medical Communication",
    "lead_mentor": "Kian (McMaster Neuroscience Scholar)",
    "co_mentor": "English Specialist",
    "threshold_struct": {
      "primary_domain": "STEM",
      "conditions": [
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "HUM",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 5,
    "node_id": "N05",
    "category_name": "Pure Quantitative Engineering",
    "lead_mentor": "Kian + Math Lead",
    "co_mentor": "Calculus Specialist",
    "threshold_struct": {
      "primary_domain": "ENG",
      "conditions": [
        {
          "domain": "ENG",
          "op": ">=",
          "value": 0.4
        },
        {
          "domain": "AI",
          "op": "<",
          "value": 0.25
        },
        {
          "domain": "STEM",
          "op": "<",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 6,
    "node_id": "N06",
    "category_name": "Quantitative Finance",
    "lead_mentor": "Sadeghi (AI Lead)",
    "co_mentor": "Math Specialist",
    "threshold_struct": {
      "primary_domain": "ENG",
      "conditions": [
        {
          "domain": "ENG",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 7,
    "node_id": "N07",
    "category_name": "Chemical & Materials Engineering",
    "lead_mentor": "Kian (McMaster Neuroscience Scholar)",
    "co_mentor": "Chemistry Specialist",
    "threshold_struct": {
      "primary_domain": "ENG",
      "conditions": [
        {
          "domain": "ENG",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 8,
    "node_id": "N08",
    "category_name": "Mechanical & Aerospace",
    "lead_mentor": "Physics Specialist",
    "co_mentor": "Kian (McMaster Neuroscience Scholar)",
    "threshold_struct": {
      "primary_domain": "ENG",
      "conditions": [
        {
          "domain": "ENG",
          "op": ">=",
          "value": 0.35
        },
        {
          "domain": "HUM",
          "op": "<",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 9,
    "node_id": "N09",
    "category_name": "Pure Software Systems",
    "lead_mentor": "Sadeghi (AI Lead)",
    "co_mentor": "Full-Stack Specialist",
    "threshold_struct": {
      "primary_domain": "AI",
      "conditions": [
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.45
        },
        {
          "domain": "STEM",
          "op": "<",
          "value": 0.2
        }
      ]
    }
  },
  {
    "priority_order": 10,
    "node_id": "N10",
    "category_name": "Applied AI Engineering",
    "lead_mentor": "Sadeghi (AI Lead)",
    "co_mentor": "Kian (McMaster Neuroscience Scholar)",
    "threshold_struct": {
      "primary_domain": "AI",
      "conditions": [
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.45
        },
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.2
        }
      ]
    }
  },
  {
    "priority_order": 11,
    "node_id": "N11",
    "category_name": "Bio-Informatics & AI Health",
    "lead_mentor": "Sadeghi (AI Lead)",
    "co_mentor": "Kian (McMaster Neuroscience Scholar)",
    "threshold_struct": {
      "primary_domain": "AI",
      "conditions": [
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.3
        }
      ]
    }
  },
  {
    "priority_order": 12,
    "node_id": "N12",
    "category_name": "Autonomous AI Robotics",
    "lead_mentor": "Sadeghi (AI Lead)",
    "co_mentor": "Physics Specialist",
    "threshold_struct": {
      "primary_domain": "AI",
      "conditions": [
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "ENG",
          "op": ">=",
          "value": 0.3
        }
      ]
    }
  },
  {
    "priority_order": 13,
    "node_id": "N13",
    "category_name": "AI Product & Vibe Coding",
    "lead_mentor": "Sadeghi (AI Lead)",
    "co_mentor": "Product Design Lead",
    "threshold_struct": {
      "primary_domain": "AI",
      "conditions": [
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.35
        },
        {
          "domain": "HUM",
          "op": ">=",
          "value": 0.2
        }
      ]
    }
  },
  {
    "priority_order": 14,
    "node_id": "N14",
    "category_name": "Pure Pre-Law & Rhetoric",
    "lead_mentor": "English Specialist",
    "co_mentor": "Academic Logic Lead",
    "threshold_struct": {
      "primary_domain": "HUM",
      "conditions": [
        {
          "domain": "HUM",
          "op": ">=",
          "value": 0.4
        },
        {
          "domain": "STEM",
          "op": "<",
          "value": 0.2
        },
        {
          "domain": "AI",
          "op": "<",
          "value": 0.2
        }
      ]
    }
  },
  {
    "priority_order": 15,
    "node_id": "N15",
    "category_name": "Science Policy & Ethics",
    "lead_mentor": "English Specialist",
    "co_mentor": "Kian (McMaster Neuroscience Scholar)",
    "threshold_struct": {
      "primary_domain": "HUM",
      "conditions": [
        {
          "domain": "HUM",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "STEM",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 16,
    "node_id": "N16",
    "category_name": "Digital Media & AI Communication",
    "lead_mentor": "English Specialist",
    "co_mentor": "Sadeghi (AI Lead)",
    "threshold_struct": {
      "primary_domain": "HUM",
      "conditions": [
        {
          "domain": "HUM",
          "op": ">=",
          "value": 0.3
        },
        {
          "domain": "AI",
          "op": ">=",
          "value": 0.25
        }
      ]
    }
  },
  {
    "priority_order": 17,
    "node_id": "N17",
    "category_name": "Multidisciplinary Exploratory Scholar",
    "lead_mentor": "Kian (Academic Director)",
    "co_mentor": "Sadeghi (AI Lead)",
    "threshold_struct": {
      "primary_domain": "FALLBACK",
      "conditions": []
    }
  }
]